"use client";

import { cn } from "@/lib/utils";
import { eventStatus, type EventDisplayStatus } from "@/lib/eventStatus";
import type { Event } from "@/types/event";

type EventLike = Pick<Event, "startDate" | "endDate" | "status">;

interface StatusPillProps {
  status?: EventDisplayStatus;
  event?: EventLike;
  className?: string;
}

const META: Record<
  EventDisplayStatus,
  { label: string; text: string; dot: string; live?: boolean }
> = {
  live: {
    label: "CANLI",
    text: "text-success-light",
    dot: "bg-success",
    live: true,
  },
  today: { label: "BUGÜN", text: "text-brand-light", dot: "bg-brand" },
  prep: {
    label: "HAZIRLANIYOR",
    text: "text-warning-light",
    dot: "bg-warning",
  },
  planned: {
    label: "PLANLANDI",
    text: "text-muted",
    dot: "bg-muted",
  },
  past: {
    label: "BİTTİ",
    text: "text-muted",
    dot: "bg-muted",
  },
};

function StatusPill({ status, event, className }: StatusPillProps) {
  const resolved: EventDisplayStatus =
    status ?? (event ? eventStatus(event) : "planned");
  const m = META[resolved];
  // On mobile the dot alone carries these two: "past" is implied by the Geçmiş tab,
  // "live" by the pulsing dot. Desktop rows have the room for the label.
  const labelMobileHidden = resolved === "past" || m.live;

  return (
    <span
      className={cn(
        "stamp inline-flex items-center gap-1.5",
        m.text,
        className,
      )}
      aria-label={m.label}
    >
      {m.live ? (
        <span className="live-dot" aria-hidden />
      ) : (
        <span
          className={cn("inline-block h-1.5 w-1.5 rounded-full", m.dot)}
          aria-hidden
        />
      )}
      <span className={labelMobileHidden ? "hidden lg:inline" : undefined}>
        {m.label}
      </span>
    </span>
  );
}

export { StatusPill, type StatusPillProps };
